import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DoubleDecimalPattern, MinimumDepositAmount } from '../../../../core/services/constant';
import { Fraction } from 'fraction.js';

@Component({
    selector: 'app-deposit',
    templateUrl: './deposit.component.html',
    styleUrls: ['./deposit.component.scss'],
    standalone: false
})
export class DepositComponent implements OnInit {
  form: UntypedFormGroup;
  showFormError: boolean = false;
  difference?:number;
  amount:Fraction = new Fraction(0,1);

  MinimumDepositAmount = MinimumDepositAmount;
  DoubleDecimalPattern = DoubleDecimalPattern;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private modal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.formBuilder.group({
      amount: [
        null,
        [
          Validators.required,
          Validators.min(MinimumDepositAmount),
          Validators.pattern(DoubleDecimalPattern),
        ],
      ],
    });
  }

  submit() {
    if (this.form.invalid) {
      this.showFormError = true;
      return;
    }

    let amount = this.form.value.amount;

    this.modal.close(amount);
  }

  close() {
    this.modal.dismiss();
  }
}
